import { useEffect } from 'react';
import DashboardLayout from 'components/layout/dashboard-layout/dashboard-layout.component';
import AuthenticatedRoute from 'components/PrivateRoute';
import { useLastActive } from 'hooks/useLastActive';
import gdpRoutes from './gdp-routes';
import NiceModal from '@ebay/nice-modal-react';
import { TellUsQuestionsModal } from './dashboard/components/tell-us-questions/tell-us-question-modal';
import { useFetchProfile } from 'hooks/useFetchProfile';

const GDPModule = () => {
  const { fetchProfile } = useFetchProfile();
  useLastActive();

  useEffect(() => {
    (async () => {
      const userResponse: any = await fetchProfile();
      // check logic show tell us here
      if (!userResponse.user.onboardingStepProgress?.info) NiceModal.show(TellUsQuestionsModal);
    })();
  }, [fetchProfile]);

  return (
    <DashboardLayout>
      {gdpRoutes.map((route) => (
        <AuthenticatedRoute
          key={route.key}
          path={route.path}
          exact={route.exact}
          name={route.name}
          component={route.component}
          role={route.role}
        />
      ))}
    </DashboardLayout>
  );
};

const nestedRoutes = [
  '/dentist/patients/:caseId',
  '/dentist/patients/:caseId/design/:designId',
  '/dentist/patients/:caseId/design/:designId/patient-proposal/create',
  '/dentist/patients/:caseId/design/:designId/patient-proposal/:proposalId/edit',
  '/dentist/education/:contentId',
  '/dentist/education/assign/:contentId',
];

export const gdpRoutesToCheck = gdpRoutes.map((route) => route.path).concat(...nestedRoutes);

export default GDPModule;
